import { Injectable } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TnrAuthProviderService } from '@tnr/ng-oauth2';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TnrAuthGuard {
  constructor(
    private tnrAuthProvideService: TnrAuthProviderService,
    private router: Router
  ) {}

  private fn = async (): Promise<boolean> => {
    const isAuthenticated = await firstValueFrom(this.tnrAuthProvideService.isAuthenticated$);

    if (!isAuthenticated) {
      this.router.navigate(['/auth/login']);
      return false;
    }
    return true;
  };

  canActivate: CanActivateFn = this.fn;
  canActivateChild: CanActivateFn = this.fn;
}
